export interface RegistrationFormFields {
  title: string
  firstName: string
  lastName: string
  addressId: string
  phone: string
  address1: string
  address2?: string
  city: string
  stateCode: string
  country: string
  postalCode: string
  preferred: boolean
  email: string
  password: string
  bonusCardInfo?: string | undefined
  bonusCardNumber?: string
  receiveBonusCard?: boolean
  marketingCommunications?: string
  global?: string
  deviceCode?: string
}

export enum MarketingCommunications {
  ACCEPTED = 'acceptMarketing',
  DECLINED = 'declineMarketing'
}

export enum BonusCardType {
  INSTORE = 'inStore',
  DIGITAL = 'digital'
}
